import { render } from "./ApplyModelsPopup.vue?vue&type=template&id=06165cba&scoped=true"
import script from "./ApplyModelsPopup.vue?vue&type=script&lang=js"
export * from "./ApplyModelsPopup.vue?vue&type=script&lang=js"

import "./ApplyModelsPopup.vue?vue&type=style&index=0&id=06165cba&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06165cba"]])

export default __exports__